import React, { useMemo, useState } from 'react';
import styles from './LoginInput.module.scss';

const eyeOpen = 'src/svg/vectors/eyeOpen.svg';

const LoginInput = ({
  formik,
  name,
  label,
  type = 'text',
  placeholder,
  autoComplete,
  disabled,
  actionLabel,
  onActionClick,
  svg,
  className,
}) => {
  const error = formik?.touched?.[name] && formik?.errors?.[name];

  const isPassword = type === 'password';
  const [showPassword, setShowPassword] = useState(false);

  const inputType = useMemo(() => {
    if (!isPassword) return type;
    return showPassword ? 'text' : 'password';
  }, [isPassword, type, showPassword]);

  return (
    <div className={`${styles.field} ${className || ''}`}>
      {(label || actionLabel) && (
        <div className={styles.labelRow}>
          {label && (
            <label className={styles.label} htmlFor={name}>
              {label}
            </label>
          )}

          {actionLabel && (
            <button
              type='button'
              className={styles.actionBtn}
              onClick={onActionClick}
            >
              {actionLabel}
            </button>
          )}
        </div>
      )}

      <div className={styles.inputWrap}>
        {svg ? (
          <div className={styles.leftIcon}>
            <img src={svg} alt='' />
          </div>
        ) : null}

        <input
          id={name}
          name={name}
          type={inputType}
          className={`${styles.input} ${svg ? styles.withLeftIcon : ''} ${
            isPassword ? styles.withRightIcon : ''
          } ${error ? styles.inputError : ''}`}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          value={formik.values[name] ?? ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          aria-invalid={!!error}
          aria-describedby={error ? `${name}-error` : undefined}
        />
        {isPassword ? (
          <button
            type='button'
            className={styles.eyeCont}
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            <div
              className={`${styles.slash} ${!showPassword ? styles.slashOn : ''}`}
            />

            <img src={eyeOpen} alt='' />
          </button>
        ) : null}
      </div>

      {error ? (
        <p id={`${name}-error`} className={styles.errorText}>
          {formik.errors[name]}
        </p>
      ) : null}
    </div>
  );
};

export default LoginInput;
